// Types
import { Action } from "../actions/types";

// Type state
type State = {
  bankAccount: any;
  pad: any;
};

// Initial state
const INITIAL_STATE: State = {
  bankAccount: {},
  pad: { signedUp: false, paymentMethod: "" },
};

export default (state: State = INITIAL_STATE, action: Action): State => {
  switch (action.type) {
    case "EDIT_COMPANY_BANK":
      return { ...state, bankAccount: action.data };
    case "CLEAR_COMPANY_BANK":
      return {
        ...state,
        bankAccount: INITIAL_STATE.bankAccount,
        pad: INITIAL_STATE.pad,
      };
    case "EDIT_COMPANY_PAD":
      return { ...state, pad: action.data };
    default:
      return state;
  }
};
